import ToastError from "../components/molecules/ToastError"
import { getClientIPAddress, sendToLogServer } from "../core/service/BusinessLogicService"
import { apigateway } from "../intances/apigateway"
import { getUsername } from "./authorization.js"
import React from "react"
import toast from "react-hot-toast"

export const createOrderSimulation = async ({ tunnelData, selectedPack, basketContent, productsCreateOrder }) => {
  if (!tunnelData) return
  if (!selectedPack) return
  if (!basketContent) return
  if (!productsCreateOrder) return

  const username = getUsername()
  const ipAdress = await getClientIPAddress()
  const { rentDTO } = selectedPack

  const promoCode = rentDTO?.promotion && rentDTO?.promotionDTOs?.length > 0 ? rentDTO?.promotionDTOs[0].code : null

  return apigateway(tunnelData)
    .post(`api/v2/order/create/${tunnelData.tenant}`, {
      packService: {
        idsPack: [
          {
            id: selectedPack?.servicePackDTO.id,
            duration: tunnelData?.data?.order?.rent?.duration
          }
        ]
      },
      promoCode: promoCode,
      productOrder: {
        supplierReference: basketContent.shop.value.split("-")[1],
        products: productsCreateOrder
      },
      sellerLogin: username,
      customer: {
        ipAddress: ipAdress,
        language: tunnelData.lang
      }
    })
    .then((res) => {
      sendToLogServer(
        "INFO",
        `PDI Retail CreateOrder SUCCESS for Tenant ${JSON.stringify(tunnelData.tenant)} and response : ${JSON.stringify(
          res.data
        )}`
      )

      return res.data
    })
    .catch((error) => {
      const {
        response: { data }
      } = error

      sendToLogServer(
        "ERROR",
        `PDI Retail CreateOrder KO for Tenant ${JSON.stringify(tunnelData.tenant)}. Error : ${JSON.stringify(data)}`
      )
      toast.error((t) => <ToastError message={data.message} handlePictoClick={() => toast.dismiss(t.id)} />, {
        id: data.message
      })
    })
}
